import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateConfirmClickedPayload {
  shiftId: string;
}

/**
 * Fires when an office clicks the "Confirm" button on the Confirm Candidate page
 * Event: dental_portal:confirm_candidate:confirm_clicked
 */
export function fireConfirmCandidateConfirmClicked(
  payload: IConfirmCandidateConfirmClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:confirm_clicked', {
    shift_id: payload.shiftId,
  });
}
